import update from "immutability-helper";

import {
  GALLERIES_LOADED,
  GALLERIES_LOADING,
  GALLERY_DETAILS_LOADED,
  GALLERY_DETAILS_LOADING,
  GALLERY_SET_INITIAL_STATE,
  GALLERY_SET_PUBLIC_PAGE,
  GALLERY_UPDATING_PUBLIC_PAGE,
} from "../actions/types";
import type { Clip } from "../state/story_authoring/reducer";

export interface StoryGallery {
  _id: string;
  type: string;
  story: string;
  title: string;
  description: string;
  thumbnailURL: string;
  archiveURL: string;
  getThumbnailURL: string;
  duration: number;
  author: string;
  custom_archive_media_type: string;
  projectName: string;
}
export type GallerySyncStatusType = "public" | "unpublished" | "outOfSync" | "publishing";

export interface Gallery {
  _id: string;
  author: string;
  backgroundURL: string;
  created_at: string;
  elements: StoryGallery[];
  clips: Clip[];
  title: string;
  description: string;
  thumbnail: string;
  getBackgroundURL: string;
  background: string;
  logoURL: string;
  organization: string;
  thumbnailURL: string;
  logo: string;
  loadingGallery: boolean;
  isUpdatingGalleyPublicPage: boolean;
  sharePageUrl: string;
  getThumbnailURL: string;
  getLogoURL: string;
  colorStart: string;
  colorEnd: string;
  updated_at: string;
  out_of_sync_messages: string[];
  sync_status: GallerySyncStatusType;
  author_name: string;
}

export interface Galleries {
  galleries: Gallery[];
  loadingGalleries: boolean;
  galleryDetail: Gallery;
}

const initialState: Galleries = {
  galleries: [],
  loadingGalleries: true,

  galleryDetail: {
    thumbnail: "",
    getThumbnailURL: "",
    updated_at: "",
    out_of_sync_messages: [],
    _id: "",
    loadingGallery: false,
    title: "",
    description: "",
    author: "",
    backgroundURL: "",
    elements: [],
    clips: [],
    getBackgroundURL: "",
    background: "",
    logoURL: "",
    organization: "",
    thumbnailURL: "",
    logo: "",
    getLogoURL: "",
    colorStart: "",
    colorEnd: "",
    created_at: "",
    // stories: [],
    isUpdatingGalleyPublicPage: false,
    sharePageUrl: "",
    sync_status: "public",
    author_name: "",
  },
};

const galleriesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GALLERIES_LOADING: {
      return update(state, { loadingGalleries: { $set: true } });
    }
    case GALLERIES_LOADED: {
      return update(state, { galleries: { $set: payload }, loadingGalleries: { $set: false } });
    }
    case GALLERY_DETAILS_LOADED: {
      const newDetails = { ...initialState.galleryDetail, ...payload };
      return update(state, {
        galleryDetail: { $set: newDetails },
      });
    }
    case GALLERY_DETAILS_LOADING:
      return update(state, {
        galleryDetail: {
          loadingGallery: { $set: true },
        },
      });
    case GALLERY_SET_PUBLIC_PAGE:
      return update(state, {
        galleries: {
          $set: payload.galleries,
        },
      });
    case GALLERY_UPDATING_PUBLIC_PAGE:
      return update(state, {
        galleryDetail: {
          isUpdatingGalleyPublicPage: { $set: payload },
        },
      });
    case GALLERY_SET_INITIAL_STATE:
      return update(state, {
        galleryDetail: {
          $set: initialState.galleryDetail,
        },
      });

    default:
      return state;
  }
};

export default galleriesReducer;
